if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;
      this.handleErrorMessage();

      const skipCartCheckout = this.dataset.skipCartCheckout === 'true';
      const cn = this.cartNotification;

      if (!skipCartCheckout && cn && typeof cn.setActiveElement === 'function') {
        cn.setActiveElement(document.activeElement);
      }

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner') && this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');

      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      if (!skipCartCheckout && cn && typeof cn.getSectionsToRender === 'function') {
        formData.append('sections', cn.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          if (skipCartCheckout) {
            const next =
              (typeof window.routes !== 'undefined' &&
                window.routes.checkout_url) ||
              '/checkout';
            window.location.assign(next);
            return;
          }

          if (
            window.swCartDrawer &&
            typeof window.swCartDrawer.open === 'function'
          ) {
            window.swCartDrawer.open();
            return;
          }

          if (cn && typeof cn.renderCartContent === 'function') {
            cn.renderCartContent(response);
          } else {
            document.dispatchEvent(new CustomEvent('cart:updated'));
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          const spin = this.querySelector('.loading-overlay__spinner');
          if (spin) spin.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
